var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section bg-gray-2",class:_vm.$style.SectionRowItem},[_c('div',{staticClass:"container"},[_c('Viedo',{attrs:{"is-row-item":"","is-video":"","list":_vm.formattedTopList,"link-type":"list","content-type":"video"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }